<template>
  <div class="sorting-controls">
    <div class="sorting-label">Sort by:</div>
    <div class="sort-options">
      <button 
        v-for="option in sortOptions" 
        :key="option.key"
        :class="['sort-button', { active: sortKey === option.key }]"
        @click="sortBy(option.key)"
      >
        {{ option.label }}
        <span v-if="sortKey === option.key" class="sort-direction">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M6 9l6 6 6-6" v-if="sortOrder === 'asc'"/>
            <path d="M18 15l-6-6-6 6" v-else/>
          </svg>
        </span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SortingControls',
  props: {
    sortKey: {
      type: String,
      default: 'title'
    },
    sortOrder: {
      type: String,
      default: 'asc'
    }
  },
  data() {
    return {
      sortOptions: [
        { key: 'title', label: 'Title' },
        { key: 'category', label: 'Category' },
        { key: 'instructor', label: 'Instructor' },
        { key: 'minutes', label: 'Duration' },
        { key: 'status', label: 'Status' },
        { key: 'is_premium', label: 'Premium/Free' },
        { key: 'students', label: 'Popularity' }
      ]
    };
  },
  methods: {
    sortBy(key) {
      let order = this.sortOrder;
      
      if (this.sortKey === key) {
        order = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        order = 'asc';
      }
      
      this.$emit('sort', { key, order });
    }
  }
};
</script>

<style scoped>
.sorting-controls {
  background: white;
  border-radius: 16px;
  padding: 0.75rem 1.5rem;
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  border: 1px solid #E2E8F0;
}

.sorting-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: #475569;
  margin-right: 1rem;
}

.sort-options {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.sort-button {
  background: #F1F5F9;
  border: none;
  border-radius: 8px;
  padding: 0.5rem 0.875rem;
  font-size: 0.75rem;
  font-weight: 500;
  color: #64748B;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.2s;
}

.sort-button:hover {
  background: #E2E8F0;
}

.sort-button.active {
  background: #EEF2FF;
  color: #4F46E5;
  font-weight: 600;
}

.sort-direction {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.sort-direction svg {
  width: 16px;
  height: 16px;
}

@media (max-width: 768px) {
  .sorting-controls {
    flex-direction: column;
    align-items: flex-start;
    padding: 1rem;
  }

  .sorting-label {
    margin-bottom: 0.75rem;
  }

  .sort-options {
    width: 100%;
  }
}
</style> 